<template>
  <div>     
    <!--
    <div class="box-header title-boreder">
      <div class="row">
        <div class="col-md-2">
          <h3 class="box-title box-title-sub">{{this.title}} </h3>
        </div>
          <div class="col-md-8">
        <div class="progressContainer text-center">
          <div class="status-bar-">
            <strong class="status-bar-title-percentage">asd%</strong>
            <strong class="status-bar-title">asd</strong>
          </div>
            <div class="progress status-bar-invenrory pull-right" >
              <div :class="'progress-bar progress-bar-' + 100" role="progressbar"
                aria-valuemin="0" aria-valuemax="100" :style="'width:' + 50+ '%'">
              </div>
            </div>
        </div>
      </div>
        <div class="col-md-2">
            <img src="/static/img/icons/ic_doc2.png" style="padding-bottom:6px;"> 
        </div>
      </div>
    </div>
   -->
    <div class="box-header title-boreder">
      <div class="row">
        <div class="col-md-2">
          <h3 class="box-title box-title-sub">{{this.title}} </h3>
        </div>
        <div style="position:relative; top: -10px !important">
        <table class="table-summary" style="padding:10px !important">
          <thead>
            <tr>
              <th>SKU {{this.unit}} Cuadradas</th>
              <th>SKU {{this.unit}} Inventariadas</th>
              <th>% {{this.title}}</th>
            </tr>      
          </thead>
          <tbody>
            <tr>
              <td>{{this.totalSkuSquare | formatAmount}}</td>
              <td>{{this.totalSkuInventory | formatAmount}}</td>
              <td v-bind:style="formatAmountColor(this.totalEriPercentage)">{{this.totalEriPercentage}}%</td>
            </tr> 
          </tbody> 
        </table>
        </div>
      </div>
       </div>
    <br/>
    <div class="row">
      <div class="col-md-12">
        <div :id="this.id" class="table-scroll">
          <div class="table-wrap">
            <table class="main-table">
              <thead>
                <tr>
                  <th class="fixed-side" scope="col">
                    <div class="sideHeader">
                      &nbsp;
                    </div>
                  </th>
                  <th class="header" v-for="item in this.formattedData" :key="'header_' + item.date">
                    {{ item.date }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th class="fixed-side">
                    SKU {{this.unit}} 
                    <br>
                    Cuadradas
                  </th>
                  <td class="td-value" v-for="item in this.formattedData" :key="'skuSquare_' + item.date">
                    {{ item.skuSquare | formatAmount }}
                  </td>
                </tr>
                <tr>
                  <th class="fixed-side">
                    SKU {{this.unit}} 
                    <br>
                    Inventariadas
                  </th>
                  <td class="td-value" v-for="item in this.formattedData" :key="'skuInventory_' + item.date">
                    {{ item.skuInventory | formatAmount }}
                  </td>
                </tr>
                <tr>
                <th class="fixed-side">
                    %
                    <br>
                    {{this.title}} 
                  </th>
                  <td class="td-value" v-for="item in this.formattedData" :key="'percentage_' + item.date">
                    <b>{{ (((item.skuSquare * 100) / item.skuInventory) || 0) | formatDecimal }}%</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from 'assets/js/util.js'
import moment from 'moment/moment.js'

export default {
  name: 'EriDetail',
  props: [
    'id',
    'title',
    'unit',
    'period',
    'data'
  ],
  data () {
    return {
      loader: null,
      formattedData: null,
      totalSkuSquare: 0,
      totalSkuInventory: 0,
      totalEriPercentage: 0
    }
  },
  watch: {
    data: function (newVal, oldVal) {
      this.loadData()
    }
  },
  created () {
    this.loadData()
  },
  components: {
  },
  computed: {
  },
  mounted () {
    $('#' + this.id).find('.main-table').clone(true).appendTo('#' + this.id).addClass('clone')
  },
  methods: {
    loadData () {
      let rawData = []
      let formattedData = []
      let totalSkuSquare = 0
      let totalSkuInventory = 0

      if (this.data) {
        this.data.forEach(function (item) {
          let newItem = {
            date: moment(item.date).format('DD/MM'),
            skuSquare: item.squaredSkuCount,
            skuInventory: item.inventoriedSkuCount
          }

          totalSkuSquare += newItem.skuSquare
          totalSkuInventory += newItem.skuInventory

          rawData.push(newItem)
        })
      }

      let selectedtMonth = this.period.substr(4, 2)
      let selectedMonthDays = moment().month(selectedtMonth - 1).daysInMonth()

      for (let index = 1; index <= selectedMonthDays; index++) {
        let dayMonth = index.toString().padStart(2, '0') + '/' + selectedtMonth

        let dayItem = {
          date: dayMonth,
          skuSquare: 0,
          skuInventory: 0
        }

        let found = rawData.find(function (dataItem) {
          return dataItem.date === dayMonth
        })

        if (found) {
          dayItem.skuSquare = found.skuSquare
          dayItem.skuInventory = found.skuInventory
        }

        formattedData.push(dayItem)
      }

      this.totalSkuSquare = totalSkuSquare
      this.totalSkuInventory = totalSkuInventory
      this.formattedData = formattedData

      this.totalEriPercentage = ((this.totalSkuSquare * 100) / this.totalSkuInventory)
      this.totalEriPercentage = this.totalEriPercentage || 0
      this.totalEriPercentage = this.$options.filters.formatDecimal(this.totalEriPercentage)
    },
    formatAmountColor (percentage) {
      let style = {
        color: util.getChartColors(percentage).solid
      }

      return style
    }
  }
}
</script>

<style>

/* Summary*/
.table-summary {
  float: right;
}

.table-summary td {
font-size: 24px;
}

.table-summary th, .table-summary td {
  padding-left: 5px;
  padding-right: 5px;
}

.table-summary th {
	background:#FFFFFF;
  color:rgba(54,74,93,0.5);
  width: 350px;
  text-align: center;
  text-transform: uppercase;
}

.table-summary td {
  text-align: center;
}

/* Detail*/
.sideHeader {
  width: 135px;
}

.table-scroll {
	position:relative;
	max-width:100%;
	margin:auto;
	overflow:hidden;
}

.table-wrap {
	width:100%;
	overflow:auto;
}
.table-scroll table {
	width:100%;
	margin:auto;
	border-collapse:separate;
	border-spacing:0;
}
.table-scroll th, .table-scroll td {
	padding:5px 10px;
	border:1px solid #E7E7E7;
	background:#fff;
	white-space:nowrap;
	vertical-align: middle;
}
.table-scroll thead {
	background:#f9f9f9;
}
.clone {
	position:absolute;
	top:0;
	left:0;
	pointer-events:none;
}
.clone th, .clone td {
	visibility:hidden
}
.clone td, .clone th {
	border-color:transparent
}
.clone tbody th {
	visibility:visible;
	/* color:green; */
}
.clone .fixed-side {
	border: none;
  color: #364A5D;
	visibility:visible;
}

.clone thead{
  background:transparent;
}

th.header {
  color: #364A5D;
  text-align: center;
}

.td-value {
  text-align: center;
}

.status-bar-invenrory{
  height: 15px !important;
  width: 40%;
  margin-left: 5%;
}

</style>



// WEBPACK FOOTER //
// EriDetail.vue?56182e32